import React from "react";

const Thumbnails = (props) => {
    return <div className="thumbnail-container" style={{ height: props.config?.containerHeight }}>
        <div className="thumbnail-list">
            {
                (props.images || []).map(m => (
                    <div key={"thumbnail-item-" + m.page} className={"thumbnail-item " + (props.currentPageNumber == m.page ? "current-page" : "")}>
                        <img
                            src={m.url}
                            width={100}
                            height={127} 
                            onClick={e => props.handleThumbnailClick(m.page)}
                            style={{transform: `rotate(${props.rotatedPages?.[m.page] || 360}deg)`,}}
                        />
                        <div className="thumbnail-page-number">{m.page}</div>
                    </div>
                ))
            }
        </div>
    </div>
}

export default Thumbnails;